import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import Hierarchy from "../../../components/common/Hierarchy";
import Progress from "../../../components/Progress";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import LeaveCreditsPagePresenter from "./LeaveCreditsPagePresenter";
import InputFactory from "../../../components/InputFactory";

class LeaveCreditsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveCreditsPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 50,
      current: 1,
      isScheduler: false,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const isScheduler = this.getCurrentRoles()?.some(
      (item) => item.id?.toLowerCase() === "scheduler",
    );
    this.setState({ isScheduler });
  }

  getCollectionName() {
    return "employees";
  }

  handleViewData(data) {
    this.navigateTo(`/leave_credits/${data.id}`);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getDisplayKeys() {
    return (this.presenter.keys || []).map((key) =>
      key === "position" ? "positionLabel" : key,
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;

    if (!schema) return <Progress />;

    schema.fields = {
      ...schema.fields,
      positionLabel: { type: "String", label: "Position" },
    };

    const displayKeys = this.getDisplayKeys();
    const excludeFields = Object.keys(schema.fields).filter(
      (key) => !displayKeys.includes(key),
    );

    return (
      <div className="overflow-auto" style={{ marginTop: "5rem" }}>
        <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
          <div className="p-3 p-lg-4">
            <div
              className="d-flex mb-4"
              style={{ borderBottom: "1.5px solid #d3d3d3" }}
            >
              <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                You are here: Home {">"} Human Resource {">"}{" "}
                <span
                  style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                >
                  Leave Credits
                </span>
              </p>
            </div>

            <CardView style={{ borderRadius: 0 }}>
                <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        ![
                          "earnings",
                          "sex",
                          "civil",
                          "month",
                          "year",
                          "lengthOfService",
                          "employmentType",
                        ].includes(field),
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

            <div style={{ marginTop: "20px", width: "100%" }}>
              <CardView style={{ borderRadius: 0 }}>
                <h4 className="text-primary">Leave Credits</h4>
              </CardView>
            </div>

            <Table
              viewObject={this.handleViewData.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              actionsList={[
                {
                  label: <i className="bi bi-search"> View</i>,
                  actionType: "viewEmployee",
                },
              ]}
              excludeFields={excludeFields}
              onClickItem={this.onClickItem.bind(this)}
            />
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default withRouter(LeaveCreditsPage);
